export const getErrorStatus = (error) => {
    if (typeof error !== 'object' || error === null) {
        return undefined;
    }
    const { statusCode, status, details } = error;
    for (const candidate of [statusCode, status, details?.status]) {
        if (typeof candidate === 'number') {
            return candidate;
        }
    }
    return undefined;
};
export const shouldRetryOnError = (error) => {
    const status = getErrorStatus(error);
    return status === undefined || status < 400 || status >= 500;
};
